import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from "../_defaults";
import type { OrderableParameters, PaginationParameters } from "../_types";

/**
 * Creates a shallow copy of the options object
 */
export function optionsWithDefaults<T>(options?: T): T {
  return { ...options } as T;
}

/**
 * Adds default orderBy array to options if not present
 */
export function optionsWithDefaultsOrderable<T extends { parameters?: OrderableParameters } | undefined>(
  options?: T,
): T & { parameters: { orderBy: OrderableParameters["orderBy"] } } {
  return {
    ...options,
    parameters: {
      ...options?.parameters,
      orderBy: options?.parameters?.orderBy ?? [],
    },
  } as T & { parameters: { orderBy: OrderableParameters["orderBy"] } };
}

/**
 * Adds default pagination and ordering values to options
 */
export function optionsWithDefaultsPaginated<
  T extends { parameters?: OrderableParameters & PaginationParameters } | undefined,
>(
  options?: T,
): T & {
  parameters: {
    orderBy: OrderableParameters["orderBy"];
    page: number;
    pageSize: number;
  };
} {
  return {
    ...options,
    parameters: {
      page: DEFAULT_PAGE,
      pageSize: DEFAULT_PAGE_SIZE,
      ...options?.parameters,
      orderBy: options?.parameters?.orderBy ?? [],
    },
  } as T & {
    parameters: {
      orderBy: OrderableParameters["orderBy"];
      page: number;
      pageSize: number;
    };
  };
}
